import { yaBukanFlagOptions } from '@/constants/flagAndCategory';
import { invoiceTemplates } from '@/constants/invoiceTemplate';
import { invoiceStatusOptions } from '@/constants/status';

const headers = [
  { title: 'No. Invoice', key: 'code', sortable: true },
  { title: 'Tgl. Terbit', key: 'issue_date', sortable: true },
  { title: 'Revisi', key: 'is_revision', sortable: true, align: 'center' },
  { title: 'Perusahaan', key: 'company_name', sortable: true },
  { title: 'Customer', key: 'customer_name', sortable: true },
  { title: 'Total Tagihan', key: 'total_amount', align: 'end', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'No. Invoice', key: 'code', type: 'text' },
  { title: 'Tgl. Terbit (awal)', key: 'issue_date_from', type: 'date' },
  { title: 'Tgl. Terbit (akhir)', key: 'issue_date_to', type: 'date' },
  { title: 'Revisi', key: 'is_revision', type: 'select', selectOptions: yaBukanFlagOptions },
  { title: 'Perusahaan', key: 'company_name', type: 'text' },
  { title: 'Customer', key: 'customer_name', type: 'text' },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: invoiceStatusOptions.map(({ value, title }) => ({ value, title })),
  },
  {
    title: 'Template',
    key: 'template',
    type: 'select',
    selectOptions: invoiceTemplates.map(({ value, title }) => ({ value, title })),
  },
];

export { filters, headers };
